export enum Permission {
  MANAGE_PRINCIPALS = 'manage_principals',
  MANAGE_DEPLOYMENTS = 'manage_deployments',
  VIEW_EXECUTIONS = 'view_executions',
}

export const ALL_PERMISSIONS: Array<Permission> = Object.values(Permission)

export function hasPermission (permissions: Array<string> | null, required: Permission): boolean {
  if (!permissions) return false
  return permissions.includes(required)
}
